import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Tperson from '../../Assets/icons/3person.svg';
import alertIcon from '../../Assets/icons/alert_icon.svg';
import callAssistantIcon from '../../Assets/icons/call_assistant_icon.svg';
import carIcon from '../../Assets/icons/car_icon.svg';
import openMailIcon from '../../Assets/icons/open_email_icon.svg';
import searchCarIcon from '../../Assets/icons/search_car_icon.svg';
import truckIcon from '../../Assets/icons/truck_icon.svg';
import Shield from '../../Assets/images/Shield.png';
import carImage from '../../Assets/images/car_content_image.png';
import { SEARCH_ROUTE, CLAIM_STATUS_ROUTE, THIRD_PARTY_CLAIM_ROUTE } from '../../Components/Router/constant';
import { useFormContext } from '../../Context/DeclarationContext';
import homeIcon from '../../Assets/images/bro.png';
import openEmailIcon from '../../Assets/icons/open_email_icon.svg';

import './home.scss';
import { Row, message } from 'antd';
import { ArrowRightOutlined } from '@ant-design/icons';

export const Home = () => {
  const { state, dispatch } = useFormContext();
  let queryString = new URLSearchParams(window.location.search);

  useEffect(() => {
    dispatch({
      type: 'SET_HEADER_TITLE',
      payload: '',
    });
  }, []);

  useEffect(() => {
    const statusCode = queryString.get('status') ?? '';

    if (statusCode === '401') {
      message.error('El enlace al que intenta ingresar ya expiró.');
    }
  }, []);

  return (
    <>
      <div className="home">
        <div className="welcome_message">
          <h3
            style={{
              marginTop: '56px',
              fontSize: '32px',
            }}
          >
            ¡Te damos la bienvenida!
          </h3>

          <h4
            style={{
              marginTop: '8px',
              fontWeight: '300',
              fontSize: '32px',
            }}
          >
            {' '}
            Identifica el Vehículo Siniestrado
          </h4>
          <Row justify="center" className="welcome_buttons" style={{ marginTop: '42px', marginBottom: '56px' }}>
            <div className="welcome_btn">
              <Link to={SEARCH_ROUTE} className="actions-btn">
                <div className="home_icon">
                  <img src={carIcon} alt="carIcon" />
                </div>
                <strong>Declaración de siniestro</strong>
              </Link>
            </div>

            <div className="welcome_btn">
              <Link to={process.env.REACT_APP_THEFT_NOTIFICATION_URL || '/'} className="actions-btn">
                <div className="home_icon">
                  <img src={alertIcon} alt="alertIcon" />
                </div>
                <strong>Aviso de robo total del vehículo</strong>
              </Link>
            </div>

            <div className="welcome_btn">
              <Link to={CLAIM_STATUS_ROUTE} className="actions-btn">
                <div className="home_icon">
                  <img src={searchCarIcon} alt="seguimientoIcon" />
                </div>
                <strong>Seguimiento de siniestros y reclamos</strong>
              </Link>
            </div>

            <div className="welcome_btn">
              <Link to={THIRD_PARTY_CLAIM_ROUTE} className="actions-btn">
                <div className="home_icon">
                  <img src={Tperson} alt="thirdPartyIcon" />
                </div>
                <strong>Reclamos de terceros</strong>
              </Link>
            </div>
          </Row>
        </div>
        <Row justify={'center'}>
          <div
            className="content"
            style={{
              marginBottom: '108px',
              width: '55%',
              border: '1px solid rgba(34, 178, 96, 0.8)',
              borderRadius: '17px',
              paddingTop: '50px',
              paddingBottom: '50px',
              display: 'flex',
              justifyContent: 'space-around',
            }}
          >
            <div className="info" style={{ marginLeft: '55px' }}>
              <p style={{ fontSize: '20px', width: '100%' }}>
                Si te gustaría ver el protocolo de manera más detallada, puedes descargarlo en el siguiente botón.
              </p>

              <div style={{ marginBottom: '25px' }}>
                <a className="download" href="/protocolo_de_siniestro.pdf">
                  Descargar protocolo {`${'->'}`}
                </a>
              </div>
            </div>

            <div className="image" style={{ marginRight: '85px' }}>
              <img
                src={homeIcon}
                alt="carImage"
                style={{
                  zIndex: '2',
                  position: 'relative',
                }}
              />
            </div>
          </div>
        </Row>
      </div>
      <div className="landing-content-component section4">
        <div
          className="message1"
          style={{
            color: 'white',
            marginTop: 0,
            paddingTop: '100px',
          }}
        >
          Información de contacto
        </div>

        <div className="cards">
          <div className="card">
            <div>
              <img src={truckIcon} alt="truckIcon" />
            </div>

            <div>
              <strong style={{ color: 'white' }}>Grúas y Asistencia en Ruta 24/7</strong>
            </div>

            <div>+56 2 3278 5997</div>

            <ul>
              <li>Remolque o transporte del vehículo por accidente o avería.</li>
              <li>Cambio de neumático.</li>
              <li>Carga y/o paso de corriente a baterías.</li>
              <li>Apertura de vehículos cerrados.</li>
            </ul>
          </div>

          <div className="card">
            <div>
              <img src={callAssistantIcon} alt="callAssistantIcon" />
            </div>

            <div>
              <strong style={{ color: 'white' }}>
                Emergencias Gama 24/7 <br /> Aviso de Robo Vehículo
              </strong>
            </div>

            <div>+56 2 2757 4450</div>

            <ul>
              <li>Denuncia del robo de forma inmediata ante la unidad policial más cercana (PDI y/o Carabineros).</li>
            </ul>

            <div
              style={{
                color: 'white',
                marginTop: '50px',
              }}
            >
              <Link
                style={{
                  borderRadius: '36px',
                  background: '#22B260',
                  width: '260px',
                  padding: '8px 32px',
                  justifyContent: 'center',
                  alignItems: 'center',
                  gap: '8px',
                  fontSize: '16px',
                  fontStyle: 'normal',
                  fontWeight: '600',
                  lineHeight: '22px',
                }}
                to={process.env.REACT_APP_THEFT_NOTIFICATION_URL ?? ''}
              >
                Aviso de robo aquí <ArrowRightOutlined />
              </Link>
            </div>
          </div>

          <div className="card">
            <div>
              <img src={openEmailIcon} alt="openEmailIcon" />
            </div>

            <div>
              <strong style={{ color: 'white' }}>Dudas Declaración de Siniestro</strong>
            </div>

            <div>+56 2 2757 4400</div>

            <ul>
              <li>Ante dudas o consultas: siniestros@gamamobility.cl</li>
            </ul>
          </div>
        </div>
      </div>
    </>
  );
};
